import { gql } from "@apollo/client";

export const WARNING_REVIEW_ALLOWED = gql`
    mutation warningReviewAllowed {
        warningReviewAllowed {
            limit
            remaining
            ok
        }
    }
`;

export const WARNING_REVIEW_SUBMIT = gql`
    mutation warningReviewSubmit(
        $warningId: ID!
        $requestType: RequestType!
        $reasonId: ID
        $description: String!
    ) {
        warningReviewSubmit(
            warningId: $warningId
            requestType: $requestType
            reasonId: $reasonId
            description: $description
        ) {
            ok
        }
    }
`;
